import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { createBundle } from 'widget/Common';
import ErrorDemoH5 from 'pages/ErrorDemo';
// 报错测试页面
import ErrorDemo from 'biz-micro-services-ui/project/middlePlatform/pages/errorDemo';
// 页面找不到组件
import NotFound from 'bundle-loader?lazy&name=NotFoundView!widget/NotFound/NotFoundView';
// 默认首页
import ShopHomeView from 'pages/Shop/Home/ShopHome/ShopHomeView';
// AI图文详情（改为懒加载）
import AIImageTextView from 'bundle-loader?lazy&name=AIImageTextView!pages/AICreation/AIImageText/AIImageTextView';
// AI视频详情（改为懒加载）
import AiVideoDetailView from 'bundle-loader?lazy&name=AiVideoDetailView!pages/AICreation/AiVideoDetail/AiVideoDetailView';

// 注册
import RegisterRouterConfig from 'pages/Register/RouterConfig';
// 登录
import LoginRouterConfig from 'pages/Login/RouterConfig';
// 商城
import ShopRouterConfig from 'pages/Shop/RouterConfig';
// 展业
import PromoteRouterConfig from 'pages/Promote/RouterConfig';
// 分享
import ShareRouterConfig from 'pages/Share/RouterConfig';
// 店铺
import StoreRouterConfig from 'pages/Store/RouterConfig';
// 学习
import LearnRouterConfig from 'pages/Learn/RouterConfig';
// 下载app
import DownLoadConfig from 'pages/DownLoad/RouterConfig';

// 打卡
import PunchClickRouterConfig from 'pages/PunchClock/RouterConfig';

// 查看文件（改为懒加载）
import FileSeeView from 'bundle-loader?lazy&name=FileSeeView!pages/FileSee/FileSeeView';

import MapRouterConfig from 'pages/Map/RouterConfig';
// 中间跳转页面（改为懒加载）
import TransitView from 'bundle-loader?lazy&name=TransitView!pages/Transit/TransitView';

const routerList = [
  {
    path: '/',
    // // 直接渲染内容，用render
    // render: () => {
    //   return <h3>默认首页</h3>
    // }
    // 首页不做懒加载，减少首屏时间
    title: '首页',
    component: () => ShopHomeView
  },
  {
    path: '/shop/home',
    // // 直接渲染内容，用render
    // render: () => {
    //   return <h3>默认首页</h3>
    // }
    // 懒加载组件，用component，且组件使用createBundle包裹
    title: '首页',
    component: () => ShopHomeView
  },
  {
    path: '/aiCreation/aiImageText/AIImageTextDetail',
    title: 'AI图文',
    component: () => createBundle(AIImageTextView)
  },
  {
    path: '/aiCreation/aiVideoDetail',
    title: 'AI视频详情',
    component: () => createBundle(AiVideoDetailView)
  },
  {
    path: '/fileSee',
    title: '查看文件',
    component: () => createBundle(FileSeeView)
  },
  {
    path: '/ErrorDemo',
    title: '报错测试',
    component: () => ErrorDemo
  },
  {
    path: '/ErrorDemoH5',
    title: '报错测试H5',
    component: () => ErrorDemoH5
  },
  ,
  {
    path: '/transit',
    title: '中间跳转页面',
    component: () => createBundle(TransitView)
  },

  ...RegisterRouterConfig,
  ...LoginRouterConfig,
  ...ShopRouterConfig,
  ...PromoteRouterConfig,
  ...ShareRouterConfig,
  ...StoreRouterConfig,
  ...LearnRouterConfig,
  ...DownLoadConfig,
  ...PunchClickRouterConfig,
  ...MapRouterConfig
];

const getRouter = () => (
  <div style={{ height: '100%' }}>
    <Switch>
      {routerList.map((route, idx) => {
        if (location.hash == `#${route.path}`) {
          // 写死“有享云商”，不取route的title，是为了兼容微信、钉钉等不可动态改变title的问题
          // document.title = '有享云商1111' || route.title || '';
        }
        if (route.render) {
          return <Route key={`route_${idx}`} path={route.path} exact component={route.render} />;
        }
        return <Route key={`route_${idx}`} path={route.path} exact component={route.component()} />;
      })}
      <Route component={createBundle(NotFound)} />
    </Switch>
  </div>
);

export { getRouter };



// WEBPACK FOOTER //
// ./src/router/index.js